import { ReactNode, createContext, useRef, useState } from 'react'
import { AlertData } from '../types'

type ContextProps = {
    activeId?: string
    alerts: Map<string, AlertData>
    closeAlert: () => void
    openAlert: (id: string) => void
    registerAlert: (id: string, data: AlertData) => void
    unregisterAlert: (id: string) => void
}

type Props = {
    children?: ReactNode
}

export const PortalAlertContext = createContext({} as ContextProps)

const PortalAlertContextManager = ({ children }: Props) => {
    const alertsRef = useRef<Map<string, AlertData>>(new Map())
    const [activeId, setActiveId] = useState<string | undefined>()

    function closeAlert() {
        setActiveId(undefined)
    }

    function openAlert(id: string) {
        setActiveId(id)
    }

    function registerAlert(id: string, data: AlertData) {
        alertsRef.current.set(id, data)
    }

    function unregisterAlert(id: string) {
        alertsRef.current.delete(id)
    }

    return (
        <PortalAlertContext.Provider
            value={{ activeId, alerts: alertsRef.current, closeAlert, openAlert, registerAlert, unregisterAlert }}
        >
            {children}
        </PortalAlertContext.Provider>
    )
}

export default PortalAlertContextManager
